import React from 'react'
import LuxPlusLabel from 'luxPlus/components/LuxPlusLabel'

interface Props {
  luxPlusInclusions: Array<Cruises.InclusionItemView>;
}

function CruiseLuxPlusOnboardCreditLabel({ luxPlusInclusions } : Props) {
  const { totalCreditAmount, creditCurrency } = luxPlusInclusions.find(({ type }) => type === 'ONBOARD_CREDIT') || {}

  return <>
    {!!totalCreditAmount && !!creditCurrency && <LuxPlusLabel
      type="onboard-credit"
      saveAmount={totalCreditAmount}
      currency={creditCurrency}
    />}
  </>
}

export default CruiseLuxPlusOnboardCreditLabel
